export default __webpack_public_path__ + "static/media/withoutButtons.d9fbf50a.png";